import { useQuery } from '@tanstack/react-query';

import { billingInfoRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useSingleBill = () => {
  const query = useQuery({
    queryKey: [QueryKeys.SINGLE_BILL],
    queryFn: () => billingInfoRepo.getSingleBill(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseSingleBill = ReturnType<typeof useSingleBill>;
